import { useLanguage } from '../../context/LanguageContext';
function LanguageSwitcher() {
  const { language, languages, setLanguage, translate } = useLanguage();
  return <label className="language-switcher"><span>{translate('Language')}</span><select aria-label={translate('Language')} onChange={(event) => setLanguage(event.target.value)} value={language}>{languages.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}</select></label>;
}
export default LanguageSwitcher;
